import {
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import AllShops from "./AllShops/AllShops";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import RentalDashboard from "./RentalSpace/RentalDashboard";

function OutletDashboard() {
  // const url = new URL(window.location.href);
  // const rental = url.searchParams.get("rental");
  // const [menuOption, setMenuOption] = useState("shop");

  // useEffect(() => {
  //   if (rental) {
  //     setMenuOption("rental");
  //   }
  // }, [rental]);
  return (
    <Box>
      <AllShops />
    </Box>
    // <div className="d-flex " style={{ justifyContent: "space-between" }}>
    //   <div style={{ width: "18%" }}>
    //     <MenuList>
    //       <MenuItem
    //         onClick={() => setMenuOption("shop")}
    //         sx={{ backgroundColor: menuOption === "shop" ? "#ddd" : "" }}
    //       >
    //         <ListItem>
    //           <ListItemIcon>
    //             <ShoppingCartIcon />
    //           </ListItemIcon>
    //           <ListItemText primary={"F&B"} />
    //         </ListItem>
    //       </MenuItem>
    //       <MenuItem
    //         onClick={() => setMenuOption("rental")}
    //         sx={{ backgroundColor: menuOption === "rental" ? "#ddd" : "" }}
    //       >
    //         <ListItem>
    //           <ListItemIcon>
    //             <HomeWorkIcon />
    //           </ListItemIcon>
    //           <ListItemText primary={"Other Space"} />
    //         </ListItem>
    //       </MenuItem>
    //     </MenuList>
    //   </div>
    //   <div style={{ width: "80%" }}>
    //     {menuOption === "shop" && <AllShops />}
    //     {menuOption === "rental" && <RentalDashboard />}
    //   </div>
    // </div>
  );
}

export default OutletDashboard;
